import { addLabels, isActive } from "@otto-ec/global-resources/apm";
import { onLoad } from "@otto-ec/global-resources/dom";

/*                            */
const LabelPrefix = "components-count_";

const instanceMap = new Map<string, null[]>();

let instances = 0;

/*                                                        */
export function addInstance(tag: string): void {
  if (!instanceMap.has(tag)) instanceMap.set(tag, []);
  const list = instanceMap.get(tag)!;
  list.push(null);
  instances += 1;
}

/*                                                                    */
if (import.meta.env.PROD && !import.meta.env.STORYBOOK) {
  /*                    */
  onLoad.sub(async () => {
    /*                                              */
    if (!(await isActive())) return;

    /*                                    */
    addLabels(
      /*                                          */
      Object.fromEntries([
        /*                           */
        [`${LabelPrefix}total`, instances],
        /*                          */
        ...[...instanceMap.entries()].map(([tag, list]) => [
          `${LabelPrefix}${tag.toLowerCase()}`,
          list.length,
        ]),
      ]),
    );

    instanceMap.clear();
  });
}
